module.exports = __webpack_public_path__ + "img/restaurant-16.268d680a.jpg";